module.exports = __webpack_public_path__ + "img/8574663.svg";